module.exports = __webpack_public_path__ + "img/bg-gc-default.5d2e1ab1.png";